import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { subscribe_welcome_path } from '../routes.js';
import {
  CreateTeamSubscriptionParams,
  createTeamSubscription,
} from '../utils/backend-api/groupSubscription';

export default function useTeamSubscriptionCreate() {
  const { mutateAsync, mutate, isLoading } = useMutation(
    (params: CreateTeamSubscriptionParams) => createTeamSubscription(params),
    {
      onSuccess: () => {
        window.location = subscribe_welcome_path();
      },
      onError: (errors: { message: string }) => {
        toast.error(errors.message);
      },
    }
  );
  return { mutateAsync, mutate, isLoading };
}
